import * as supportsFeature from "./feature/index.js";
import * as supportsQuery from "./query.js";
/**
 * @public
 */
export var Supports;
(function (Supports) {
    Supports.Property = supportsFeature.Property;
    Supports.Query = supportsQuery.Query;
    Supports.isProperty = Supports.Property.isProperty;
    Supports.query = Supports.Query.of, Supports.isQuery = Supports.Query.isQuery;
    Supports.parse = Supports.Query.parse;
})(Supports || (Supports = {}));
//# sourceMappingURL=index.js.map